module.exports = new __parcel__URL__("flow-builder-dark.9551fc28.svg").toString();